module.exports = __webpack_public_path__ + "img/times.847a4cc9.svg";